<template>
  <ModalMask menu @click="onClose">
    <div class="side-menu modal-main">
      <div class="title">
        <Button v-if="showStoreList" icon @click="showStoreList = false">
          <ArrowLightIcon class="return" small />
        </Button>
        <DaichoLogo v-else />
      </div>
      <StoreSelect
        v-if="showStoreList"
        :current="currentStore.id"
        showLogout
        isSP
        @select="handleStoreSelect"
        @logout="logout"
      />
      <template v-else>
        <div class="store" @click="toggleStoreList">
          <span class="name">{{ currentStore.name }}</span>
          <ArrowLightIcon v-if="storeSelectable" small />
        </div>
        <div class="navigation">
          <div class="list">
            <a class="item" @click="goTo('')"><ListIcon :frame="false" />予約一覧</a>
            <a class="item" @click="goTo('reserve/history')"><HistoryIcon />受付履歴</a>
            <a class="item" @click="goTo('customer')"><CustomerIcon />顧客台帳</a>
            <a class="item" @click="goTo('analysis/dashboard')"><AnalysisIcon />分析</a>
            <a class="item" @click="goTo('alert')">
              <Badge :show="!!currentStore.counts.alert" :text="formatExceed(currentStore.counts.alert)">
                <BellIcon />
              </Badge>
              アラート
            </a>
            <a class="item" href="/pdf/info/daicho_sp_manual.pdf" target="_blank"> <HelpIcon />ヘルプ </a>
          </div>
          <div class="reserve">
            <Button @click="goTo('reserve/new')">新規予約</Button>
          </div>
        </div>
      </template>
    </div>
  </ModalMask>
</template>

<script>
import queryString from 'querystring'
import { mapState } from 'vuex'
import { formatExceed } from '@/utils/number'
import ModalMask from '@/components/molecules/ModalMask'
import Badge from '@/components/molecules/Badge'
import Dialog from '@/components/molecules/ModalDialog'
import StoreSelect from '@/components/organisms/Header/StoreSelect'
import Button from '@/components/atoms/Button'
import DaichoLogo from '@/components/icons/logo'
import ArrowLightIcon from '@/components/icons/arrowLight'
import ListIcon from '@/components/icons/ListIcon'
import HistoryIcon from '@/components/icons/history'
import CustomerIcon from '@/components/icons/customer'
import AnalysisIcon from '@/components/icons/analysis'
import BellIcon from '@/components/icons/bell'
import HelpIcon from '@/components/icons/help'

/**
 * SP版ページ
 */
export default {
  name: 'SideMenu',
  components: {
    ModalMask,
    Badge,
    StoreSelect,
    Button,
    DaichoLogo,
    ArrowLightIcon,
    ListIcon,
    HistoryIcon,
    CustomerIcon,
    AnalysisIcon,
    BellIcon,
    HelpIcon,
  },
  props: {
    /** 店舗選択時のイベントハンドラ */
    onSelect: Function,
    /** 店舗選択可能かどうか */
    storeSelectable: { type: Boolean, default: false },
  },
  data() {
    return {
      showStoreList: false,
    }
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      editing: state => state.app.editing,
      currentStore: state => state.stores.current.store,
    }),
  },
  mounted() {
    this.$store.dispatch('stores/current/get')
  },
  methods: {
    formatExceed,
    toggleStoreList() {
      if (this.storeSelectable) this.showStoreList = true
    },
    handleStoreSelect(id) {
      if (this.onSelect) {
        this.onSelect(id)
        return
      }
      const { path, query } = this.$route
      location.assign(`${path}?${queryString.stringify({ ...query, selected_store_id: id })}`)
    },
    async goTo(target) {
      if (!this.editing || (await Dialog.confirmLeaveReserve())) {
        this.$store.commit('app/editing', false)
        this.$router.push({ path: `/sp/${target}` })
        this.onClose()
      }
    },
    onClose() {
      this.showStoreList = false
      this.$emit('close')
    },
    async logout() {
      if (!this.editing || (await Dialog.confirmLeaveReserve())) {
        if (await this.$store.dispatch('app/logout')) {
          location.replace('/sp/login')
        }
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.side-menu {
  background: var(--white);
  display: flex;
  flex-direction: column;
  height: 100%;
  transition: transform 0.3s ease;
  width: 280px;

  .modal-enter &,
  .modal-leave-to & {
    transform: translateX(-280px);
  }
}

.title {
  align-items: center;
  background: var(--brand-color);
  color: var(--white);
  display: flex;
  flex: 0 0 auto;
  height: 48px;
  padding: 0 16px;

  svg {
    fill: var(--white);
  }

  .responsive & {
    @media screen and (--sp-size) {
      height: 56px;
    }
  }
}

.return {
  transform: rotate(90deg);
}

.store {
  align-items: center;
  border-bottom: solid 1px var(--border-color);
  box-sizing: border-box;
  display: flex;
  fill: var(--brand-color);
  flex: 0 0 auto;
  font-weight: bold;
  height: 56px;
  justify-content: space-between;
  padding: 0 16px;

  svg {
    transform: rotate(-90deg);
  }
}

.navigation {
  flex: 0 1 auto;
  overflow-y: scroll;
  padding-top: 24px;
}

.item {
  align-items: center;
  color: var(--text-color);
  cursor: pointer;
  display: grid;
  fill: var(--brand-color);
  font-weight: bold;
  grid-auto-flow: column;
  grid-gap: 16px;
  grid-template-columns: 24px 1fr;
  padding: 8px 16px;

  & + & {
    margin-top: 8px;
  }

  svg {
    height: 24px;
    width: 24px;
  }
}

.reserve {
  padding: 24px 16px;

  .button {
    font-size: 15px;
    height: 48px;
    line-height: 48px;
    width: 100%;
  }
}
</style>
